export default __webpack_public_path__ + "static/media/circle-hero.63b9baa3.png";